import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	font-family: ${tokens.font_family_primary};
	gap: 8px;

	h2 {
		font-size: 16px;
		font-weight: 600;
		color: ${tokens.color_gray_dark};
	}

	h3 {
		font-size: 18px;
		font-weight: 400;
		color: ${tokens.color_gray_dark};
	}

	p {
		font-size: 16px;
		font-weight: 500;
		color: ${tokens.color_gray_dark};
	}
`;
